import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScatterplotCandidateBaseIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 9,
		fill: "currentColor",
		strokeWidth: 1,
		stroke: "#9E9E9E"
	})
});
export default SvgScatterplotCandidateBaseIcon;
